module.exports = require("core-js/modules/es.number.is-nan.js");